module.exports = __webpack_public_path__ + "static/media/portuguese.9cd8d0ac.png";